module.exports = __webpack_public_path__ + "static/media/propt1-logowepapp.6850d331.svg";